// ── Auth contract (passwordless email OTP) ──────────────────────────────────
// LIVE backend integration (swapped from the mock-first build).
//
// Login is passwordless: the citizen enters an email, the backend emails a
// one-time code, and the code is exchanged for a session token. Backend owns:
// account lookup, OTP generation/expiry/rate-limiting, email delivery, and token
// issuance.

import { apiClient } from 'src/api/client';

export { applyAuthToken, redirectToPortalHome } from './session';

// No longer thrown by this module since the live-backend swap; retained only
// for existing consumers and test doubles (EmailCodeLogin.test.tsx,
// EmailLoginSurface.test.tsx mock it).
export class AuthError extends Error {}

export async function requestOtp(input: { email: string }): Promise<void> {
  // Always resolves (neutral 200) — never reveals whether the account exists.
  // The backend only emails a code when the address maps to a real account.
  await apiClient.post('auth/request-otp', input);
}

export async function verifyOtp(input: {
  email: string;
  code: string;
}): Promise<{ token: string }> {
  return (await apiClient.post('auth/verify-otp', input)).data;
}
